module["exports"] = [
  "#####"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sv/address/postcode.js
 ** module id = 985
 ** module chunks = 0
 **/